import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from '@angular/core';

import {environment} from "@numizmat/environments";
import {
  ProfileAdResponse,
  FilterProfileAdsRequest,
  FilterProfileAdsResponse,
} from "@numizmat/services-models/core";

@Injectable({
  providedIn: 'root'
})
export class ProfileAdApiService {
  private httpClient: HttpClient = inject(HttpClient);

  private profileAdController: string = 'profileAd';

  public getAllDeletableProfileAds(): Observable<ProfileAdResponse[]> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileAdController}/deletable/all`;
    return this.httpClient.get<ProfileAdResponse[]>(endpoint);
  }

  public getAllStoppableProfileAds(): Observable<ProfileAdResponse[]> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileAdController}/stoppable/all`;
    return this.httpClient.get<ProfileAdResponse[]>(endpoint);
  }

  public getAllRenewableAfterSoldProfileAds(): Observable<ProfileAdResponse[]> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileAdController}/renewable/after-sold/all`;
    return this.httpClient.get<ProfileAdResponse[]>(endpoint);
  }

  public getAllRenewableAfterExpiredProfileAds(): Observable<ProfileAdResponse[]> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileAdController}/renewable/after-expired/all`;
    return this.httpClient.get<ProfileAdResponse[]>(endpoint);
  }

  public filterProfileAds(request: FilterProfileAdsRequest): Observable<FilterProfileAdsResponse> {
    const endpoint = `${environment.apiCoreUrl}/${this.profileAdController}/filter`;
    return this.httpClient.post<FilterProfileAdsResponse>(endpoint, request);
  }
}
